import { UnPhotoContext } from "../context/UnPhotoContext";
import { useContext } from "react";

export const useUnPhotoContext = () => {
    const context = useContext(UnPhotoContext);

    if (!context) {
        return Error('useUnPhotoContext must be used inside an UnPhotoContextProvider');
    };

    return context;
};